// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"149f9385","133":"92d23323","477":"50e2e31e","785":"a268cc71","800":"2f37a8fe","933":"fc35258e","997":"a7d1e4a8"}[chunkId] + ".chunk.js";
};